var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.333 38C6.333 20.52 20.52 6.334 38 6.334 55.48 6.334 69.667 20.52 69.667 38S55.48 69.667 38 69.667C20.52 69.667 6.333 55.48 6.333 38zm14.22-.456c0-10.422 8.588-18.825 19.072-18.537 9.66.268 17.733 8.342 18.001 18.022.288 10.463-8.115 19.051-18.536 19.051a18.478 18.478 0 01-11.225-3.79c-.99-.74-1.071-2.203-.186-3.089.721-.741 1.874-.803 2.698-.185a14.288 14.288 0 008.713 2.945c8.032 0 14.54-6.57 14.417-14.623-.124-7.662-6.57-14.108-14.212-14.211-8.032-.124-14.623 6.405-14.623 14.417h3.687c.927 0 1.38 1.112.762 1.75l-5.767 5.747a1.02 1.02 0 01-1.462 0l-5.747-5.746c-.659-.639-.206-1.751.721-1.751h3.687z",
    fill: "#4A4A4A"
  })));
}
export default __webpack_public_path__ + "static/media/SoftReset.b3ef7bdc.svg";
export { SvgSoftReset as ReactComponent };